import React, { useState, useEffect } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import Spacer from "./spacer"

const Header = ({ isPress }) => {
	const { header } = useStaticQuery(graphql`
		query HeaderQuery {
			header: datoCmsHeader {
				links {
					... on DatoCmsHeaderLink {
						id
						title
						link
					}
					... on DatoCmsHeaderNestedLink {
						id
						title
						nestedLinks {
							id
							link
							title
						}
					}
				}
			}
		}
	`)
	return (
		<header className='masthead'>
			<MenuInner isPress={isPress} links={header.links} />
		</header>
	)
}

export default Header

const MenuInner = ({ isPress, links }) => {
	const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)

	const openForm = () => document.body.classList.add("popup-open")

	const toggleSubmenu = () => setIsSubmenuOpen(o => !o)

	return (
		<div className='flex align-center p20 max-1600 ma'>
			<Link className='link ml20 m-m0 mra pos-rel z-2' to='/'>
				<div className='logo--main' />
			</Link>
			{/* {isPress !== true && (
				<div className='mla mra medium flex m-hide'>
					{links.map(link => {
						if (link.id.includes("NestedLink")) return <DesktopSubmenu key={link.id} isSubmenuOpen={isSubmenuOpen} toggleSubmenu={toggleSubmenu} links={link.nestedLinks} title={link.title} />
						return (
							<Link key={link.id} activeStyle={{ opacity: 1, color: "#fff" }} to={link.link} className='link m0 mr40 op-link pointer' role='presentation'>
								{link.title}
							</Link>
						)
					})}
				</div>
			)} */}
			<div className='mla m-hide'>
				{/* <Link to='/blog' className='m0 op-link link mr10 m-inline'>
					Blog
				</Link> */}
				<p className='m0 button mr20 m-m0 m-white' role='presentation' onClick={openForm}>
					<span className='m-hide'>Connect with us</span>
					<span className='m-show'>Contact</span>
				</p>
			</div>
			<MobileMenu links={links} />
		</div>
	)
}

const DesktopSubmenu = ({ toggleSubmenu, isSubmenuOpen, links, title }) => {
	return (
		<div className='pos-rel '>
			<p className='m0 mr40 op-link pointer' role='presentation' onClick={toggleSubmenu}>
				{title}
			</p>
			<div className={`desktop-submenu overflow ${isSubmenuOpen ? "open" : "close"}`}>
				<div className='inner medium lh-none '>
					{links.map(link => (
						<Link key={link.id} activeStyle={{ opacity: 1, color: "#fff" }} className='link op-75' to={link.link}>
							{link.title}
						</Link>
					))}
				</div>
			</div>
		</div>
	)
}

const MobileMenu = ({ links }) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false)
	const openForm = () => document.body.classList.add("popup-open")
	const closeMenu = () => setIsMenuOpen(false)

	useEffect(() => {
		// Avoid serverside rendering where window is not available
		if (typeof window !== "undefined") {
			const params = new URLSearchParams(window.location.search);
			if (params.get("contactus") === "true") {
				openForm();
			}
		}
	}, []);

	return (
		<>
			<div className={`mla hamburger--icon m-show pos-rel z-2 ${isMenuOpen && "open"}`} onClick={() => setIsMenuOpen(o => !o)} role='presentation' />
			<div className={`mobile--menu m-show bt1 ${isMenuOpen && "open"}`}>
				{/* <Spacer /> */}
				{/* <div className='p20 flex flex-col gap-20'>
					{links.map(link => {
						if (link.id.includes("NestedLink")) return <MobileMenuDropdown closeMenu={closeMenu} title={link.title} links={link.nestedLinks} />
						return <MobileMenuItem key={link.id} closeMenu={closeMenu} title={link.title} link={link.link} />
					})}
				</div> */}
				{/* <Spacer className='small' /> */}
				<p className='m20 button med m-white' role='presentation' onClick={openForm}>
					CONNECT WITH US
				</p>
			</div>
		</>
	)
}

const MobileMenuItem = ({ title, link, closeMenu }) => {
	return (
		<div className='bb1 menu-item'>
			<Link activeStyle={{ opacity: 1, color: "#fff" }} to={link} className='h2 grey link block mb20' onClick={closeMenu}>
				{title}
			</Link>
		</div>
	)
}

const MobileMenuDropdown = ({ closeMenu, title, links }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false)
	return (
		<div className={`menu--dropdown bb1 ${isDropdownOpen && "open"}`}>
			<div className='mb20'>
				<p className='h2 grey pointer flex space-between align-center justify-between' role='presentation' onClick={() => setIsDropdownOpen(o => !o)}>
					<span>{title}</span>
					<span className='mla chevron-down' />
				</p>
				<div className='dropdown--content'>
					<div className='inner xlarge'>
						{links.map(link => (
							<Link key={link.id} activeStyle={{ opacity: 1 }} className='link mt20 block op-75' to={link.link} onClick={closeMenu}>
								{link.title}
							</Link>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
